export var DigitalGiftCardDeliveryMethod;
(function (DigitalGiftCardDeliveryMethod) {
    DigitalGiftCardDeliveryMethod[DigitalGiftCardDeliveryMethod["EMAIL_RECEIPT"] = 1] = "EMAIL_RECEIPT";
    DigitalGiftCardDeliveryMethod[DigitalGiftCardDeliveryMethod["TEXT_RECEIPT"] = 2] = "TEXT_RECEIPT";
    DigitalGiftCardDeliveryMethod[DigitalGiftCardDeliveryMethod["EMAIL_ME"] = 3] = "EMAIL_ME";
    DigitalGiftCardDeliveryMethod[DigitalGiftCardDeliveryMethod["TEXT_ME"] = 4] = "TEXT_ME";
})(DigitalGiftCardDeliveryMethod || (DigitalGiftCardDeliveryMethod = {}));
export var DeliveryMethodType;
(function (DeliveryMethodType) {
    DeliveryMethodType["EMAIL"] = "Email";
    DeliveryMethodType["SMS"] = "SMS";
})(DeliveryMethodType || (DeliveryMethodType = {}));
